import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tooltipContainer v_tooltip mb-3" }
const _hoisted_2 = { class: "tooltip" }

import { withDefaults } from 'vue';
import InfoIcon from './icons/InfoIcon.vue';

interface IProps {
    location?: any;
    text?: string;
    icon?: string;
    color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomTooltipInfo',
  props: {
    location: { default: 'top' },
    text: { default: '' },
    icon: { default: 'mdi-information' },
    color: { default: '#FF5C00' }
  },
  setup(__props: any) {


const propsComponent = __props

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, {
    text: "",
    location: propsComponent.location,
    class: ""
  }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default"),
        _createVNode(InfoIcon, _normalizeProps(_guardReactiveProps(props)), null, 16)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(propsComponent.text), 1)
      ])
    ]),
    _: 3
  }, 8, ["location"]))
}
}

})